import React, { useState } from 'react'
import ResponsiveDrawer from '../Drawer/drawer'
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Notification from "../AlertNotification/Message";
import axios, { CancelToken, isCancel } from "axios";

const CreateOrder = () => {
    const drawerWidth = 240;
    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    return (
        <div className="mx-4">
            <ResponsiveDrawer heading="Create Order" />
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
                component="main"
            >
                <Toolbar />
                <div className="d-flex justify-content-between m-5 pt-5">
                    <h4 className="">Select&nbsp;A&nbsp;Customer</h4>
                </div>
            </Box>
            <Notification notify={notify} setNotify={setNotify} />
        </div>
    )
}

export default CreateOrder